import React from 'react';
import { Icon, IconProp } from '@benzinga/core-ui';
import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
import { faRss } from '@fortawesome/pro-regular-svg-icons/faRss';
import styled from '@benzinga/themetron';

export interface AuthorSocialMediaLinksI {
  uid: string | number;
  facebook?: string | null;
  twitter?: string | null;
  linkedin?: string | null;
}

export interface AuthorSocialI {
  social: AuthorSocialMediaLinksI;
}

export interface AuthorSocialMediaI {
  name: string;
  url: string | undefined | null;
  icon: IconProp;
}

const AuthorSocialMedia: React.FC<AuthorSocialI> = props => {
  const { facebook, linkedin, twitter, uid } = props.social;

  const socialMedia: AuthorSocialMediaI[] = [
    { icon: faRss, name: 'rss', url: `https://www.benzinga.com/author/${uid}/rss.xml` },
    { icon: faFacebook, name: 'facebook', url: facebook },
    { icon: faXTwitter, name: 'twitter', url: twitter },
    { icon: faLinkedin, name: 'linkedin', url: linkedin },
  ];

  return (
    <AuthorSocialMediaWrapper className="flex items-center gap-3">
      {socialMedia
        .filter(item => item.url)
        .map((social, i) => {
          return (
            <div className="inline-flex items-center justify-center" key={`${i}-${uid}`}>
              <a
                className={`icon rounded icon-${social.name.toLowerCase()}`}
                href={social?.url ?? '#'}
                rel="noreferrer"
                target="_blank"
                title={social.name}
              >
                {/* Use <Icon icon={social.icon} /> if social.icon is an IconProp otherwise treat it as an element */}
                <Icon icon={social.icon} />
              </a>
            </div>
          );
        })}
    </AuthorSocialMediaWrapper>
  );
};
export { AuthorSocialMedia };

const AuthorSocialMediaWrapper = styled.div`
  .icon {
    width: 25px;
    height: 25px;
    font-size: 15px;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease-in-out;
  }
  .icon:hover {
    transform: translateY(-4px);
  }
  .icon-rss {
    background: #ff6617;
    color: #fff;
  }
  .icon-facebook {
    background: #1877f2;
    color: #fff;
  }
  .icon-twitter {
    background: #000000;
    color: #fff;
  }
  .icon-linkedin {
    background: #2867b2;
    color: #fff;
  }
`;
